import { HOME_FEED_SECTION } from '@/features/settingsPage/consts/sections';
import { getSectionUrl } from '@/features/settingsPage/structs/section';

export { RESOURCE_NAME } from '@esentai/core/features/questions/consts';

export const ROUTE_PATH = getSectionUrl(HOME_FEED_SECTION);

export const FEATURE_NAME = 'feedLayoutEditPage';
